import { render, staticRenderFns } from "./ProductBulkUpdate.vue?vue&type=template&id=0ae2bd2c&scoped=true"
import script from "./ProductBulkUpdate.vue?vue&type=script&lang=js"
export * from "./ProductBulkUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProductBulkUpdate.vue?vue&type=style&index=0&id=0ae2bd2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2bd2c",
  null
  
)

export default component.exports